import React, { Fragment, useState, useEffect } from 'react'
import { useHistory } from "react-router-dom"
import { services } from '../../services'
import { Button, Card, CheckBox, Pagination, SubmissionError } from '../../components'
import CustomModal from '../../components/CustomModal'
import { ReactComponent as BackButton } from "../../assets/icons/ui/BackButton.svg"
import ExportFileModal from '../ExportFileModal'
import ExportFileContent from '../ExportFileModal/ExportFileContent'

const User = require('../../assets/icons/inventoryreference/account.svg')
const Search_SVG = require('../../assets/icons/inventoryreference/search.svg')
const Master_SVG = require('../../assets/icons/inventoryreference/Master_Account.svg')
const Location = require('../../assets/icons/inventoryreference/location.svg')
const CloseButton = require('../../assets/icons/inventoryreference/close.svg')
const RightArrow = require('../../assets/icons/inventory/RightArrow.svg')
const Search = require('../../assets/icons/ui/Search-Error.svg')
const Spinner = require('../../assets/icons/ui/loader.gif')


const { api, exportFile} = services 

const InventoryReferenceInfo = (props) => {

  const history = useHistory()
  const [refData, setRefData] = useState('')
  const [allChecked, setAllChecked] = useState(false)
  const [isChecked, setIsChecked] = useState([])
  const [modalFlag, setModalFlag] = useState(true)
  const [searchTerm, setSearchTerm] = useState('')
  const [finalDataCopy, setFinalDataCopy] = useState('')
  const [activePage, setActivePage] = useState(1)
  const [currentPage, setCurrentPage]= useState(1)
  const [pageData, setPageData] =useState('')
  const [acctDetailList, setAcctDetailList] = useState([])
  const [loading, setLoading] = useState(true)
  const [searchFlag, setSearchFlag] =useState(false)
  const [searchErrorFlag, setSearchErrorFlag] = useState(false)
  const [, setNoCloseIcon] = useState(false)
  const [isErrorModal,setIsErrorModal] = useState(false)
  const [isErrorModalStyle,setIsErrorModalStyle] = useState(false)
  const [closeIconStatus, setCloseIconStatus] = useState(true)
  const [isExportModal, setIsExportModal] = useState(false)
  const [isExportLoading, setIsExportLoading] = useState(false)
  const [isExportAll, setIsExportAll] = useState(false)
  const IS_OK = status => status === 200

  const PER_PAGE = 25
  var TOTAL_COUNT = refData.length
  var lastIndex = activePage * PER_PAGE
  var firstIndex = lastIndex - PER_PAGE
  const { onMount, savedState } = props

  useEffect(() => {
    onMount(true)
    api.ReferenceListData(savedState[0].BillAccountNumber)
      .then((response) => {
        setRefData(response.data.ReferenceAccountNumber)
        setFinalDataCopy(response.data.ReferenceAccountNumber)
        setLoading(false)
        setPageData(response.data.ReferenceAccountNumber.slice(firstIndex, lastIndex))
      })
    setAcctDetailList(savedState)

    return () => {
      onMount(false)
    }
  }, [onMount, firstIndex, lastIndex, savedState])

  const downloadFile = () => {
    setIsExportAll(true)
    setIsExportModal(true)
    setIsExportLoading(true)
    const refNums = []
    for(let i in refData){
      refNums.push(refData[i].Reference_Acct)
    }
    api.downloadedFile(refNums)
      .then((response) =>{
        if (IS_OK(response.status)) {
          exportFile.saveData(response.data)
          setIsExportLoading(false)
          setIsExportModal(false)
          setIsExportAll(false)
        }
      }, (error) => {
        setIsExportLoading(false)
        setIsExportModal(false)
        setNoCloseIcon(true)
        setIsErrorModalStyle(true)
        setIsErrorModal(true)
      })
  }

  const modalToggle = () => {
    setNoCloseIcon(false)
    setIsErrorModalStyle(false)
    setIsErrorModal(false)
  }
  const noCloseIconOnModal = () => {
    setCloseIconStatus(true)
  }
  
  const handleClick = (event, selectedReference) => {
    let tempArray = []
    tempArray.push(selectedReference)
    history.push({
      pathname: '/InventoryAccount/InventoryReferenceInfo/InventoryReport',
      state: { ReferenceInfo: tempArray , AccountList :props.savedState},
    })
    
  }

  const changeCurrentPage = (pageNumber) => {
    setCurrentPage(pageNumber)
    setActivePage(pageNumber)
    setAllChecked(false)
    lastIndex = pageNumber * PER_PAGE
    firstIndex = lastIndex - PER_PAGE
    setPageData(refData.slice(firstIndex, lastIndex))
  }
  
  const handleAllCheck = () => {
    setModalFlag(true)
    const currentPageData = pageData.map((data) => {
      return data.Reference_Acct
    })
    if (allChecked) {
      setAllChecked(false)
      setIsChecked(isChecked.filter(checked_name => !currentPageData.includes(checked_name)))
    } else if (!allChecked) {
      const uniqueAccounts = [
        ...isChecked,
        pageData.map(data => data.Reference_Acct.toString()),
      ].flat(1)
      setAllChecked(true)
      setIsChecked([...new Set(uniqueAccounts)])
    }
  }

  useEffect(() => {
    if (pageData.length > 1) {
      if (pageData.every(item => isChecked.includes(item.Reference_Acct))) {
        setAllChecked(true)
      }
    }else{
      setAllChecked(false)
      setModalFlag(false)
    }
  }, [pageData, isChecked])

  const handleSingleCheck = (e) => {
    setModalFlag(true)
    const { name } = e.target
    if (isChecked.includes(name)) {
      setIsChecked(isChecked.filter(checked_name => checked_name !== name))
      return setAllChecked(false)
    }
    setIsChecked([...isChecked, name])
  }

  
  const handleOnSubmit = (e) => {
    e.preventDefault()
  }

  const handleSearch = (event) => {
    let value = event.target.value
    setSearchFlag(true)
    let array = []
    let searchArray = []
    searchArray = finalDataCopy
    if (searchArray.length > 0 && value.length === 10) {
      setSearchErrorFlag(false)
      array = searchArray.filter(function (x, index) {
        
        let patt = new RegExp(value, 'i')

        if (patt.test(x.Reference_Acct))
          return true
       
        return false
      })
      TOTAL_COUNT = array.length
      lastIndex = TOTAL_COUNT
      firstIndex = 0
      setActivePage(1)
      setCurrentPage(1)
      setModalFlag(false)
      setPageData(array.slice(firstIndex, lastIndex))
      renderBody()
    }
    else {
      lastIndex = activePage * PER_PAGE
      firstIndex = lastIndex - PER_PAGE
      setPageData(refData.slice(firstIndex, lastIndex))
      setSearchFlag(false)
      setModalFlag(true)
    }
    setSearchTerm(value)
  }

  const handleClickSearch =() =>{
    if(searchTerm.length < 10){
      setSearchErrorFlag(true)
    }else{
      setSearchErrorFlag(false)
    }
  }

  // header card rendering function
  const accountDetailCard =() =>{
    if(refData){
      var result = refData.map(a => a.CUST_NAME)
    }
    if (acctDetailList === [] || acctDetailList === undefined || acctDetailList === "" || refData === [] || refData === undefined || refData === "") {
      return (
        <Card >
          <div className='noRecord'>No Record Found</div>
        </Card>
      )
    }
    else {
      return <div>
        {acctDetailList && refData && acctDetailList.map((data,index)=>{
          return(
            <Card key={index}>
              <div className='reference-Rowinfo'>
                <li className='reference-li'>
                  <span className="account-card-image">
                    <img src={User} alt='user-icon' />
                  </span>
                </li>
                <li className='reference-li reference-acctName-content'>
                  <div>
                    <div className="account-card-content">Account Name</div>
                    <span className="account-card-details">{result[0]}</span>
                  </div>
                </li>
                <div className = "vertical-line"></div>
                <li className='reference-li'>
                  <span className="account-card-image">
                    <img src={Master_SVG} alt='account-icon' />
                  </span>
                </li>
                <li className='reference-li reference-acct-content'>
                  <div>
                    <div className="account-card-content">Master Bill Account</div>
                    <span className="account-card-details">{data.BillAccountNumber}</span>
                  </div>
                </li>
                <div className = "vertical-line"></div>
                <li className='reference-li reference-mobile-view'>
                  <span className="account-card-image">
                    <img src={Location} alt='location-icon' />
                  </span>
                </li>
                <li className='reference-li reference-mobile-view'>
                  <div>
                    <div className="account-card-content">Address</div>
                    <span className="account-card-details">{data.ServiceAddressCompressed}</span>
                  </div>
                </li>
              </div>
            </Card>
          )
        })}
      </div>
    }
  }
  
  // Body rendering function
  const renderBody = () => {
    if (pageData === [] || pageData === undefined || pageData === "" || pageData.length === 0) {
      return (
        <div className="loading-spinner">
          <img src={Search} className ="spinner-alignment" alt="Icon"/>
          <span className="loading-message">Sorry, no result found</span>
          <span>Please check the account number and try again</span>
        </div>
      )
    }
    else {
      return <div >
        {pageData && pageData.map((data, index) => {
          return (
            <Card key = {index}>
              <div className="reference-body-card">
                <div className='reference-Rowinfo'>
                  <li className='reference-li'>
                    <span className="reference-body-checkbox">
                      <CheckBox
                        name={data.Reference_Acct}
                        value={data.Reference_Acct}
                        isChecked={isChecked.includes(data.Reference_Acct.toString())}
                        handleCheckboxClick={handleSingleCheck}
                        className="mouse-pointer"
                      />
                    </span>
                  </li>
                  <li className='reference-li'>
                    <span className="reference-body-firstcolumn">
                      {data.Reference_Acct}
                    </span>
                  </li>
                  <li className='reference-li'>
                    <span className="reference-body-secondcolumn">
                      {data.Address}
                    </span>
                  </li>
                </div>
                <div className='reference-body-button'>
                  <li className='reference-li'>
                    <Button
                      data-a11y-focus="first"
                      onClick={e => handleClick(e, data)} 
                    >
                      View
                    </Button>
                  </li>
                </div>
                <li className='reference-li reference-rightarrow' >
                  <div className='reference-body-icon'>
                    <img src={RightArrow} alt='>' /*onClick={e => handleClick(e, data)} *//>
                  </div>
                </li>
              </div>
            </Card>
          )
        })
        }
      </div>
    }
  }

  const handleShow = () => setModalFlag(false)
  
  const multipleExport = () => {
    setIsExportModal(true)
    setIsExportLoading(true)
    api.downloadedFile(isChecked)
      .then((response) =>{
        if (IS_OK(response.status)) {
          exportFile.saveData(response.data)
          setIsExportLoading(false)
          setIsExportModal(false)
        }
      }, (error) => {
        setIsExportLoading(false)
        setIsExportModal(false)
        setNoCloseIcon(true)
        setIsErrorModalStyle(true)
        setIsErrorModal(true)
      })
  }

  // hidden card for checkbox selection
  const hiddenCard = () =>{
    return(
      <Card className = "reference-hidden-card">
        <img src={CloseButton} alt='close-button' onClick={() => handleShow()} className=" ref-hidden-close mouse-pointer"/>
        <span className= "ref-hidden-card-info">{isChecked.length} Accounts Selected</span>
        <Button
          className="ref-hidden-card-button"
          aria-label={`Export CSV`}
          data-a11y-focus="first"
          onClick={multipleExport}
        >Export CSV</Button> 
      </Card>
    )
  }

  // pagination rendering function
  const paginationDiv = () =>{
    if(searchFlag){
      TOTAL_COUNT = pageData.length
      lastIndex = TOTAL_COUNT
      firstIndex = 0
    }
    return(
      <div className = "pagination">
        <span className="pagination-details">
          {pageData.length === 0 ? null : 
            <span>Showing {firstIndex === 0 ? 1 : firstIndex} - {TOTAL_COUNT <= lastIndex ? TOTAL_COUNT : lastIndex} of {TOTAL_COUNT} {lastIndex === 1 ? "number" : "numbers"}</span>}
        </span>
        {refData.length > 25 && !searchFlag ?
          <Pagination
            allChecked={allChecked}
            currentPage ={currentPage}
            activePage={activePage}
            totalSize={TOTAL_COUNT}
            sizePerPage={PER_PAGE}
            changeCurrentPage={changeCurrentPage}
            firstPageText="First"
            lastPageText="Last"
            showFirstLastPages={true}
            nextPageText="Next"        
            previousPageText="Prev"
          /> : null}
      </div>
    )
  }

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(0, object.target.maxLength)
    }
  }

  const handleCharacters = (e) => {
    setSearchErrorFlag(false)
  }


  return (
    <Fragment>
      <div className="reference-info" data-test="referenceComponent">
        <h1 className="report-outage__title">Reference Numbers</h1>
        {loading ? (
          <div className="loading-spinner">
            <img src={Spinner} className="spinner-alignment" alt="Icon" />
            <span className="loading-message">Loading .....</span>
            <span>Please wait while we load your data</span>
          </div>
        ) : (
          <div>
            {accountDetailCard()}
            <div className="reference-nav-bar" data-test="referenceContent">
              <div className="search-ref reference-search">
                <form className="search-form" onSubmit={handleOnSubmit}>
                  <div
                    className={
                      searchErrorFlag
                        ? "search-ref-error-input input-icon-wrap"
                        : "search-ref-input input-icon-wrap"
                    }
                  >
                    <input
                      type="number"
                      maxLength="10"
                      onInput={maxLengthCheck}
                      className="input-with-icon"
                      placeholder="Enter 10 digit account number without - or space"
                      name="search"
                      onChange={handleSearch}
                      onKeyPress={handleCharacters}
                    />
                    <span className="input-icon search-pointer">
                      <button
                        type="submit"
                        className="search-button"
                        alt="search-button"
                        onClick={() => handleClickSearch()}
                      >
                        <img src={Search_SVG} alt="search-button" />
                      </button>
                    </span>
                  </div>
                  {searchErrorFlag ? (
                    <div className="error-message">
            Enter 10 digit account number without - or space 
                    </div>
                  ) : null}
                </form>
              </div>
              {pageData.length === 0 ?
                <Button
                  disabled
                  className="reference-button-disabled"
                  aria-label={`Export All`}
                  data-a11y-focus="first"
                >
                    Export ALL
                </Button> : 
                <Button
                  className="reference-button"
                  aria-label={`Export All`}
                  data-a11y-focus="first"
                  onClick = {downloadFile}
                >
                  Export ALL
                </Button>
              }
              {isErrorModal && isErrorModalStyle
                ? <CustomModal
                  modalContent={ 
                    <SubmissionError
                      noCloseIcon={noCloseIconOnModal}
                      onclickOpen={modalToggle}
                      setIsErrorModalStyle={setIsErrorModalStyle}
                      tryagainClick={isExportAll 
                        ? downloadFile 
                        : multipleExport
                      }
                      setIsExportAll={setIsExportAll}
                    /> }
                  onclickOpen={modalToggle}
                  isShowContent={true}
                  hideCloseIcon={closeIconStatus}
                  noCloseIcon={noCloseIconOnModal}
                  isErrorModalStyle={isErrorModalStyle}
                  setIsErrorModalStyle={setIsErrorModalStyle}
                  setIsExportAll={setIsExportAll}
                /> : null}
            </div>
            <Card className="reference-card">
              <span className="reference-header">
                <div className="reference-checkbox">
                  <CheckBox
                    name="checkAll"
                    value="checkAll"
                    isChecked={allChecked}
                    handleCheckboxClick={handleAllCheck}
                    className="mouse-pointer"
                  />
                </div>
                <div className="reference-header-column header-font">
          Reference No.
                </div>
                <div className="header-font">Address</div>
              </span>
            </Card>
            {renderBody()}
            {paginationDiv()}
          </div>
        )}
        {isChecked.length > 1 && modalFlag ? hiddenCard() : null}
        <section className="inventory-cancel-actions">
          <Button
            className={`-secondary inventorycancel`}
            aria-label={`Cancel and return to homepage`}
            data-a11y-focus="first"
            onClick={() => history.push("/")}
          >
       Cancel
          </Button>
          <Button
            className={`button -link-button-back -secondary back`}
            aria-label={`Back`}
            data-a11y-focus="first"
            onClick={() => history.push('/InventoryAccount')}
          >
            <BackButton/>
          </Button>
        </section>

      </div>
      <ExportFileModal isExportModal={isExportModal}>
        <ExportFileContent 
          isExportLoading={isExportLoading} 
          setIsExportModal={setIsExportModal} 
        />
      </ExportFileModal>
    </Fragment>
  )
}


export default InventoryReferenceInfo
